
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-shekel-50 to-white">
      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <span className="text-shekel-600 text-3xl font-bold">₪</span>
            <span className="font-bold text-xl text-shekel-800">Shekel</span>
          </div>
          <Link to="/login">
            <Button variant="outline">Sign In</Button>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-16 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold text-shekel-800 mb-6">
            Family Money Management Made Simple
          </h1>
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
            Teach your kids about money while keeping track of family finances. 
            Shekel makes managing allowances, savings, and spending easy for the whole family.
          </p>
          
          <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
            <Link to="/login">
              <Button size="lg" className="w-full sm:w-auto">
                Get Started
              </Button>
            </Link>
          </div>
        </div>

        {/* Features Section */}
        <div className="mt-24 grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="p-6">
            <div className="w-12 h-12 bg-shekel-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <span className="text-shekel-600 text-2xl">👨‍👩‍👧‍👦</span>
            </div>
            <h3 className="text-lg font-semibold text-shekel-800 mb-2">Family Accounts</h3>
            <p className="text-gray-600">Create accounts for each family member and track individual balances.</p>
          </div>
          
          <div className="p-6">
            <div className="w-12 h-12 bg-shekel-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <span className="text-shekel-600 text-2xl">💰</span>
            </div>
            <h3 className="text-lg font-semibold text-shekel-800 mb-2">Easy Transfers</h3>
            <p className="text-gray-600">Send money between family members with simple, secure transfers.</p>
          </div>
          
          <div className="p-6">
            <div className="w-12 h-12 bg-shekel-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <span className="text-shekel-600 text-2xl">📊</span>
            </div>
            <h3 className="text-lg font-semibold text-shekel-800 mb-2">Track Progress</h3>
            <p className="text-gray-600">Monitor spending habits and savings goals for better financial education.</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t bg-white py-8 mt-16">
        <div className="container mx-auto px-4 text-center">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <span className="text-shekel-600 text-2xl font-bold">₪</span>
            <span className="font-bold text-lg text-shekel-800">Shekel</span>
          </div>
          <p className="text-sm text-gray-500 mb-4">
            Making family financial management simple and educational.
          </p>
          <div className="flex justify-center space-x-6 text-sm text-gray-500">
            <a href="/terms.html" target="_blank" rel="noopener noreferrer" className="hover:text-shekel-600">
              Terms of Service
            </a>
            <a href="/privacy.html" target="_blank" rel="noopener noreferrer" className="hover:text-shekel-600">
              Privacy Policy
            </a>
          </div>
          <p className="text-xs text-gray-400 mt-4">
            &copy; {new Date().getFullYear()} Shekel. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
